/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material';

export const layoutMainSX = (firstSlotCount: number): SxProps<Theme> => ({
	pt: (theme) => (firstSlotCount === 0 || theme.breakpoints.down('sm') ? theme.customDimensions.layoutSpacing : 0),
	img:{
		maxWidth : '100%',
		height : 'auto',
		display:'block'
	}
});

export const layoutFooterSX:SxProps = {
	'& footer':{
		width:'100%'
	}
}

export const hideIfChildEmpty:SxProps = {
	'&:has(>:empty)': {
		display: 'none',
	}
}

export const hideIfEmpty:SxProps = {
	'&:empty': {
		display: 'none',
	},
}